import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import Fade from 'react-reveal/Fade';
import { Section, Event } from '../../../src/components/Layout';
import { Container, Row, Column } from '../../../src/components/Grid';
import Text from '../../../src/components/Typography/Text';
import theme from '../../../src/theme';
import CardWithImage from '../../../src/components/Card/CardWithImage';

const Root = styled.div`
  ${Column} {
    padding-left: ${props => props.theme.layout.gutter / 2}px;
    padding-right: ${props => props.theme.layout.gutter / 2}px;
  }
`;

class Category extends PureComponent {
  renderList = item => {
    const { i18n, t, categorySlug } = this.props;
    return (
      <Column key={item.id} mobile={1} tablet={3} desktop={3}>
        <Fade up>
          <CardWithImage
            card={{
              title: item.title,
              date: item.date,
              image: {
                url: item.visualDesk,
                height: 360,
                width: 360
              },
              link: `${t('common:brands.navigation.events')}/${categorySlug ||
                'uncategorized'}/${item.slug}`
            }}
            maxWidth={360}
            minWidth={360}
            fullHeight
          />
        </Fade>
      </Column>
    );
  };

  renderLists = () => {
    const { items } = this.props;
    return items.map(this.renderList);
  };

  render() {
    const { label, backgroundColor } = this.props;
    return (
      <Section className="category" backgroundColor={backgroundColor}>
        <Container>
          <Root>
            <Text
              variant="heading2"
              as="h2"
              color={theme.color.brand.primary}
              paddingTop="40px"
              marginBottom="40px"
            >
              {label}
            </Text>
            <Row space={10}>{this.renderLists()}</Row>
          </Root>
        </Container>
      </Section>
    );
  }
}

Category.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  items: PropTypes.array,
  categorySlug: PropTypes.string,
  backgroundColor: PropTypes.string,
  i18n: PropTypes.object,
  t: PropTypes.func
};

export default translate()(Category);
